
export const ANSWER_VOTED_TYPE = 'aWasVotedOn'
export const MEDIA_VOTED_TYPE = 'mWasVotedOn'
export const QUESTION_VOTED_TYPE = 'qWasVotedOn'
export const REVIEW_DOWNVOTED_TYPE = 'rWasDownVoted'
export const REVIEW_UPVOTED_TYPE = 'rWasUpVoted'

let sessionStorageSupported = true
try {
  const testKey = 'tt__test__support__key'
  window.sessionStorage.setItem(testKey, testKey)
  window.sessionStorage.removeItem(testKey)
} catch (e) {
  sessionStorageSupported = false
}

/**
 * Utility to retrieve int value from sessionStorage
 * @param type
 * @param id
 */
export function getSessionVarInt(type: string, id: number): number {
  if (sessionStorageSupported && window.sessionStorage.getItem(`${type}_${id}`)) {
    return parseInt(window.sessionStorage.getItem(`${type}_${id}`))
  }
  return null
}

export function getSessionVar(type: string, id: number): string {
  return sessionStorageSupported ? window.sessionStorage.getItem(`${type}_${id}`) : null
}

export function removeSessionVar(type: string, id: number): void {
  if (sessionStorageSupported) {
    window.sessionStorage.removeItem(`${type}_${id}`)
  }
}

export function setSessionVar(type: string, id: number, value: number): void {
  if (sessionStorageSupported) {
    window.sessionStorage.setItem(`${type}_${id}`, value?.toString())
  }
}
